import { IonButton, IonCheckbox, IonContent, IonHeader, IonItem, IonList, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { IonButtons } from '@ionic/react';
import { MotionSensorState } from '../../models/FrameMetadata';
import styles from '../DoorPolicyModal.module.css';
import { useState } from 'react';
import { useCommonTranslation, useModalTranslation } from '../../hooks/useTranslation';
import { getMotionSensorStateLabel } from '../../utils/doorPolicyTranslations';

export interface EditDoorPolicyMotionSensorStatePickerProps {
    motionSensorStates: MotionSensorState[];
    onSelectMotionSensorStates: (states: MotionSensorState[]) => void;
    onClose: () => void;
}

const EditDoorPolicyMotionSensorStatePicker = ({
    motionSensorStates,
    onSelectMotionSensorStates,
    onClose,
}: EditDoorPolicyMotionSensorStatePickerProps) => {
    const [selectedStates, setSelectedStates] = useState(motionSensorStates);
    const { t: tCommon } = useCommonTranslation();
    const { t: tModals } = useModalTranslation();
    const stateOptions = Object.entries(MotionSensorState)
        .filter((entry) => typeof entry[1] === 'number')
        .map(([label, value]) => ({
            label: getMotionSensorStateLabel(tModals, value as MotionSensorState),
            value: value as MotionSensorState,
        }));
    const toggleState = (value: MotionSensorState) => {
        if (selectedStates.includes(value)) {
            setSelectedStates(selectedStates.filter((state) => state !== value));
        } else {
            setSelectedStates([...selectedStates, value]);
        }
    };

    return (
        <IonPage>
            <IonHeader translucent>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="medium" onClick={onClose}>
                            {tCommon('buttons.cancel')}
                        </IonButton>
                    </IonButtons>
                    {/* ios title mode keeps the title centered in md too */}
                    <IonTitle {...({ mode: 'ios' } as object)}>{tModals('door_policy.pickers.motion_sensor_state.title')}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton
                            strong={true}
                            onClick={() => {
                                onSelectMotionSensorStates(selectedStates);
                                onClose();
                            }}
                        >
                            {tCommon('buttons.save')}
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen color="light">
                <section className={`${styles.wrapper} ${styles.section}`}>
                    <h2 className={styles.sectionLabel}>{tModals('door_policy.pickers.motion_sensor_state.heading')}</h2>
                    <IonList className={styles.listCard}>
                        {stateOptions.map((option) => {
                            const isSelected = selectedStates.includes(option.value);
                            return (
                                <IonItem
                                    key={option.value}
                                    button
                                    detail={false}
                                >
                                    <IonCheckbox
                                        checked={isSelected}
                                        onIonChange={() => {
                                            toggleState(option.value);
                                        }}
                                    >
                                        {option.label}
                                    </IonCheckbox>
                                </IonItem>
                            );
                        })}
                    </IonList>
                </section>
            </IonContent>
        </IonPage>
    );
};

export const EditDoorPolicyMotionSensorStatePickerView = (props: EditDoorPolicyMotionSensorStatePickerProps) => (
    <EditDoorPolicyMotionSensorStatePicker {...props} />
);

export default EditDoorPolicyMotionSensorStatePicker;
